<template>
  <div class="page">
    <StaticHeader v-bind:title="$root.t('account:title')"/>
    <template v-if="taken_modal">
      <div class="modal">
        <div class="modal-wrapper">
          <div>
            <a class="close" v-on:click="taken_modal = false"></a>
          </div>
          <div class="modal-form">
            <h1 v-html="$root.t(`account:taken_modal:title`)"></h1>
            <p v-html="$root.t(`account:taken_modal:text`)"></p>
          </div>
        </div>
      </div>
    </template>  
    <div class="container container-nopaddinghorizontal container-afterheader container-includestaticfooter">
      <transition name="container-overlay">
        <div class="container-overlay" v-if="searching"></div>      
      </transition>    
      <div class="container container-small container-float">
        <div class="container-column container-column-left" v-html="$root.t('account:column_left')"></div>
        <div class="container-column container-column-right" v-html="$root.t('account:column_right')"></div>
      </div>
      <div class="container" v-if="error">
          <div class="container container-small">
            <p class="modal-form-error" v-html="$root.t(`loginform:error:${error}`)"></p>
        </div>
      </div>
      <form v-else v-on:submit.prevent="submit(true)">
        <div class="container page-submitarea" :class="{'page-submitarea-fixed': $root.isScrolledMore}">
          <div class="container container-small">
            <input class="wide wide-right" type="submit" v-on:click.prevent="sendlink()" :value="$root.t('account:sendlink')">
            <input class="wide wide-left" type="submit" :value="$root.t('account:submit')">
          </div>
        </div>
        <div class="container container-small page-fields" v-if="form_data">
          <ProfileFormField v-bind:values="form_data" v-bind:data="form_field" v-bind:form_data.sync="form_data"/>
        </div>
      </form>
    </div>
    <StaticFooter/>
  </div>
</template>

<style lang="scss">
  @import "../main";
  .page {
      &-content {
          & > h1 {
              margin-top: $base-size * 2;
          }
          & > div {
              max-width: 660px;
              hyphens: auto;
              text-align: justify;
          }
      }
  }

</style>

<script>

import ProfileFormField from '@/components/ProfileFormField.vue'
import StaticHeader from '@/components/StaticHeader.vue'
import StaticFooter from '@/components/StaticFooter.vue'


export default {
  name: 'profile',
  components: {
      StaticHeader,
      StaticFooter,
      ProfileFormField
  },
  data() {
    return {
        data: null,
        searching: true,
        form_data: false,
        error: false,
        taken_modal: false,
        form_field: [
          {id: 'usermail',        name: 'account:label:usermail', type: 'text', value: ''},
          {id: 'username',        name: 'account:label:username', type: 'text', value: ''},
          {id: 'language',        name: 'account:label:language', type: 'select', value: ['Deutsch','Français','Italiano','English','Rumantsch']}
        ]
    }
  },
  mounted() {
    if (!this.$root.logindata.token) {
      this.$root.loginmodal(this.fetchData);
    } else {
      this.fetchData()
    }
  },
  watch: {
    '$route' () {
        this.fetchData(); 
    }
  },
  methods: {
    async fetchData() {
      this.data = await this.$store.dispatch('load', {mode: `/account/${this.$root.logindata.account}`});
      this.form_data = this.data.Data;
      this.form_data.usermail.Content = this.form_data.usermail.Content || "";
      this.form_data.username.Content = this.form_data.username.Content || "";
      this.form_data.language.Content = this.form_data.language.Content || [];
      this.searching = false;
    },
    async sendlink() {
        let result = await this.$store.dispatch('post', {
            mode: `/forgot`, 
            params: {email: this.form_data.usermail.Content},
            headers: {
            'Content-type': 'application/json',
            }
        });
        if (result.error === true) {
            this.error = result.message;
        } 
    },
    async submit(close) {
      close = close || false;
      this.searching = true;

      let result = await this.$store.dispatch('post', {
          mode: `/account/${this.$root.logindata.account}`, 
          params: this.form_data
      });

      this.searching = false;

      if (result.error) {
        if (result.message == 'email taken') {
          this.taken_modal = true;
        }
      }
      else {
        if (close === true) {
          this.$router.push('/');
        }        
      }
    }
  }
}
</script>
